var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 41,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.5v40.1H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 18.3h66.3v16H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#081873",
    d: "M.4 0h66.2v20.1H.4zm0 30.2H67v10H.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de3929",
    d: "M.4 23.7h66.2v3.1H.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce08",
    d: "m20.2 31.3.6 1.6h1.6l-1.3 1 .5 1.6-1.4-1-1.3 1 .5-1.6-1.4-1h1.7m15.1-13.3.5 1.6H37l-1.4 1 .6 1.6-1.4-1-1.4 1 .5-1.6-1.3-1h1.7m-17.4 5 .5 1.7h1.7l-1.4 1 .6 1.6-1.4-1-1.4 1 .5-1.6-1.3-1h1.7m18.4-2 .5 1.5H37l-1.4 1 .6 1.6-1.4-1-1.4 1 .5-1.6-1.3-1h1.7M31 14.7l.5 1.6h1.7l-1.3 1 .5 1.6-1.4-1-1.4 1 .6-1.6-1.4-1h1.7m-5-3.5.5 1.6h1.6l-1.3 1 .5 1.6-1.4-1-1.3 1 .5-1.6-1.4-1H25m-5 .2.5 1.6h1.7l-1.4 1 .5 1.6-1.3-1-1.4 1 .5-1.6-1.3-1h1.7m-2.8 3.4.5 1.6H19l-1.3 1 .5 1.6-1.4-1-1.3 1 .5-1.6-1.4-1h1.7M25.5 33l.6 1.6h1.6l-1.3 1 .5 1.6-1.4-1-1.3 1 .5-1.6-1.4-1H25m6.5-3.2L32 33h1.7l-1.4 1 .5 1.6-1.3-1-1.4 1 .5-1.6-1.3-1h1.6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.62d1b819411cfee40bf4c37c9173dc04.svg";
export { ForwardRef as ReactComponent };